export default {
  nav: {
    Down: "Download",
    ReserveGift: "Pre-register for gifts",
    CharacterIntroduction: "Character introduction",
    Gameplay: "Gameplay introduction",
    AttentionFB: "Special recharge offer",
  },
};
